import { useMemo } from 'react'
import { useAuthStore } from '@/features/auth/store'
import type { ColumnDef } from './types'

/**
 * Filters out columns whose {@link ColumnDef.requiredPermission} the current user lacks.
 * Superusers see everything. Returns the original list when no user is loaded yet
 * (caller should not render until auth resolves anyway).
 */
export function usePermissionFilteredColumns<TRow>(columns: ColumnDef<TRow>[]): ColumnDef<TRow>[] {
  const user = useAuthStore((s) => s.user)
  return useMemo(() => {
    if (!user) return columns
    if (user.superuser) return columns
    return columns.filter((c) => !c.requiredPermission || user.permissions.includes(c.requiredPermission))
  }, [columns, user])
}
